import { generateTemplates } from './Templates/index.js';
import { generateWidgets } from './Widgets/index.js';

/** A "theme" for @rjsf/core (v5): the partial `templates`/`widgets` override set that
 * @rjsf/core merges on top of its own plain defaults (see @rjsf/core's `Form.getRegistry()`
 * and `withTheme`). Everything omitted here (date/color/file/radio/range/textarea widgets,
 * ArrayFieldItemButtonsTemplate, GridTemplate, etc.) falls back to @rjsf/core's own
 * framework-agnostic built-ins automatically. */
export const generateTheme = () => ({
  templates: generateTemplates(),
  widgets: generateWidgets(),
});
